// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"1d803c71","105":"9759e99c","228":"e7ea5e08","238":"3d937953","240":"61f75081","467":"23a7b5df","513":"cbd62713","644":"d4b34b8d","686":"877bee6f","843":"e256e3d4","852":"b3e2e1bd"}[chunkId] + ".chunk.js";
};